/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    './storage/framework/views/*.php',
    './resources/**/*.blade.php',
    './resources/**/*.js',
    './resources/**/*.vue',
  ],
  plugins: [],
  theme: {
    extend: {
      container: {
        screens: { xl: '1200px' },
      },
      minWidth: {
        '103px': '103px',
        '327px': '327px',
      },
      maxWidth: {
        116: '116px',
        125: '125px',
        145: '145px',
        179: '179px',
        275: '275px',
        320: '320px',
        368: '368px',
        430: '430px',
        454: '454px',
        480: '480px',
        583: '583px',
        584: '584px',
        686: '686px',
        704: '704px',
        720: '720px',
        736: '736px',
        738: '738px',
        760: '760px',
        788: '788px',
        1024: '1024px',
        1200: '1200px',
        1250: '1250px',
        1260: '1260px',
        1280: '1280px',
      },
      width: {
        '23p': '23%',
        '24p': '24%',
        '30p': '30%',
        '31p': '31%',
        '70p': '70%',
        '2px': '2px',
        '8px': '8px',
        '12px': '12px',
        '18px': '18px',
        '22px': '22px',
        '24px': '24px',
        '26px': '26px',
        '32px': '32px',
        '40px': '40px',
        '48px': '48px',
        '50px': '50px',
        '58px': '58px',
        '72px': '72px',
        '76px': '76px',
        '94px': '94px',
        '102px': '102px',
        '103px': '103px',
        '108px': '108px',
        '111px': '111px',
        '115px': '115px',
        '130px': '130px',
        '140px': '140px',
        '144px': '144px',
        '150px': '150px',
        '160px': '160px',
        '166px': '166px',
        '175px': '175px',
        '190px': '190px',
        '195px': '195px',
        '200px': '200px',
        '210px': '210px',
        '216px': '216px',
        '222px': '222px',
        '230px': '230px',
        '241px': '241px',
        '247px': '247px',
        '257px': '257px',
        '264px': '264px',
        '277px': '277px',
        '280px': '280px',
        '295px': '295px',
        '299px': '299px',
        '300px': '300px',
        '311px': '311px',
        '319px': '319px',
        '325px': '325px',
        '327px': '327px',
        '335px': '335px',
        '343px': '343px',
        '359px': '359px',
        '379px': '379px',
        '411px': '411px',
        '420px': '420px',
        '471px': '471px',
        '442px': '442px',
        '448px': '448px',
        '480px': '480px',
        '508px': '508px',
        '520px': '520px',
        '593px': '593px',
        '616px': '616px',
        '675px': '675px',
        '685px': '685px',
        '687px': '687px',
        '704px': '704px',
        '718px': '718px',
        '720px': '720px',
        '736px': '736px',
        '738px': '738px',
        '768px': '768px',
        '780px': '780px',
        '786px': '786px',
        '800px': '800px',
        '870px': '870px',
        '960px': '960px',
        '992px': '992px',
        '1024px': '1024px',
        '1058px': '1058px',
        '1200px': '1200px',
        '1226px': '1226px',
        '1300px': '1300px',
      },
      spacing: {
        xs: '0.5rem',
        s: '1rem',
        m: '1.5rem',
        l: '2rem',
        xl: '2.5rem',
        xxl: '3rem',
        'xxl-2': '3.5rem',
        7: '1.75rem',
        13: '3.25rem',
        14: '3.5rem',
        15: '3.75rem',
        19: '4.75rem',
        21: '5.25rem',
        23: '5.75rem',
        24: '6rem',
        26: '6.5rem',
        28: '7rem',
        29: '7.25rem',
        32: '8rem',
        35: '8.75rem',
        41: '10.25rem',
        43: '10.75rem',
        48: '12rem',
        '-6px': '-6px',
        '-24px': '-24px',
        '-25px': '-25px',
        91.5: '22.875rem',
        92: '23rem',
        120: '30rem',
        150: '37.5rem',
        '2px': '2px',
        '3px': '3px',
        '4px': '4px',
        '5px': '5px',
        '6px': '6px',
        '7px': '7px',
        '8px': '8px',
        '9px': '9px',
        '10px': '10px',
        '11px': '11px',
        '12px': '12px',
        '13px': '13px',
        '14px': '14px',
        '15px': '15px',
        '16px': '16px',
        '17px': '17px',
        '18px': '18px',
        '19px': '19px',
        '20px': '20px',
        '22.5px': '22.5px',
        '23px': '23px',
        '24px': '24px',
        '25px': '25px',
        '26px': '26px',
        '27px': '27px',
        '28px': '28px',
        '30px': '1.875rem',
        '31px': '31px',
        '32px': '32px',
        '33px': '33px',
        '36px': '36px',
        '37px': '37px',
        '38px': '38px',
        '39px': '39px',
        '40px': '40px',
        '42px': '42px',
        '43px': '43px',
        '44px': '44px',
        '45px': '45px',
        '46px': '46px',
        '48px': '48px',
        '50px': '50px',
        '52px': '52px',
        '56px': '56px',
        '58px': '58px',
        '62px': '62px',
        '64px': '64px',
        '70px': '70px',
        '72px': '72px',
        '76px': '76px',
        '78px': '78px',
        '80px': '80px',
        '82px': '82px',
        '83px': '83px',
        '90px': '90px',
        '93px': '93px',
        '95px': '95px',
        '100px': '100px',
        '103px': '103px',
        '108px': '108px',
        '112px': '112px',
        '114px': '114px',
        '116px': '116px',
        '120px': '120px',
        '125px': '125px',
        '135px': '135px',
        '139px': '139px',
        '144px': '144px',
        '148px': '148px',
        '155px': '155px',
        '172px': '172px',
        '173px': '173px',
        '187px': '187px',
        '188px': '188px',
        '194px': '194px',
        '200px': '200px',
        '212px': '212px',
        '218px': '218px',
        '257px': '257px',
        '270px': '270px',
        '293px': '293px',
        '311px': '311px',
        '320px': '320px',
        '332px': '332px',
        '343px': '343px',
        '376px': '376px',
        '414px': '414px',
        '397px': '397px',
        '540px': '540px',
      },
      borderRadius: {
        6: '0.375rem',
        8: '0.5rem',
        12: '0.75rem',
        16: '1rem',
        '3px': '3px',
        '4px': '4px',
        '6px': '6px',
        '7px': '7px',
        '9px': '9px',
        '13px': '13px',
        '16px': '16px',
        '20px': '20px',
        '24px': '24px',
      },
      fontSize: {
        8: '8px',
        10: '10px',
        12: '12px',
        13: '13px',
        14: '14px',
        16: '16px',
        18: '18px',
        20: '20px',
        21: '21px',
        22: '22px',
        24: '24px',
        32: '32px',
        36: '36px',
        40: '40px',
        48: '48px',
      },
      fontFamily: {
        montserrat: ['Montserrat', 'Helvetica', 'Arial', 'sans-serif'],
      },
      boxShadow: {
        'shadow-color': '0 4px 25px 0 rgba(1, 79, 50, 0.1)',
        normal: '0 8px 25px 0 rgba(1, 79, 50, 0.2)',
      },
      colors: {
        primary: '#1f4484',
        'primary-lightest': '#009cf0',
        'hiring-chip': 'rgba(124,195,102,.2)',
        'primary-lighter': '#e6f5fd',
        'primary-darker': '#b32026',
        transparent: 'transparent',
        white: '#ffffff',
        'onyx-light': '#36363d',
        onyx: '#202028',
        'onyx-lightest': '#636368',
        'onyx-lighter': '#4c4c53',
        'charcoal-lighter': '#707174',
        'charcoal-light': '#5b5c60',
        charcoal: '#45454b',
        'charcoal-dark': '#333439',
        'chrome-lighter': '#d8d8db',
        'chrome-light': '#c4c4c9',
        'chrome-lightest': '#ebebec',
        chrome: '#b1b1b7',
        'lunar-dark': '#dfdfe0',
        'lunar-darker': '#d3d3d4',
        'lunar-darkest': '#c7c7c9',
        'linear-1': 'rgba(255, 255, 255, 0) 0%,',
        'linear-2': 'rgba(255, 255, 255, 1) 95%',
        'linear-3': 'rgba(255, 255, 255, 1) 0%',
        'linear-4': 'rgba(255, 255, 255, 0) 100%',
        'linear-5': 'rgba(255, 255, 255, 1) 100%',
        'dark-charcoal': '#2c2c2c',
      },
    },
  },
};
